angular
    .module('app')
    .component('groupsAdd', {
        templateUrl: '/templates/pages/groups/groupsAdd/groupsAdd.html',
        controller: 'GroupsAddController',
        controllerAs: 'vm',
    });